export const size =
  document.body.clientWidth >= 1024 ||
  document.documentElement.clientWidth >= 1024
    ? true
    : false;
